import {Space, Tooltip} from 'antd';
import {get} from 'lodash-es';
import React, {FC} from 'react';
import {useDispatch} from 'react-redux';

import {DynamicIcon} from 'components/dynamic-icon';
import {TIconType} from 'components/dynamic-icon/dynamic-icon';
import {IFieldMeta, TFieldStructureType} from 'entities/metadata';
import {createActionGetFile} from 'modules/data/data-actions';
import {ERequestType} from 'shared/types/requests';

interface IIconsCellProps {
    field: IFieldMeta;
    record: Record<string, any>;
}

export const IconsDownloadCell: FC<IIconsCellProps> = ({
    field, record,
}: IIconsCellProps) => {
    const {fieldStructure} = field;
    const dispatch = useDispatch();

    const handleClick = () => {
        const attachId = fieldStructure?.map(({fieldKey}) => get(record, fieldKey) as string | number);
        const referenceUrl = `${field?.referenceUrl}/${attachId || record.id}`;
        dispatch(
            createActionGetFile({referenceUrl, requestType: ERequestType.GET}),
        );
    };
    const renderIcons = () => fieldStructure?.map(({
        fieldKey, iconName, prefixForField = '',
    }: TFieldStructureType) => (
        <Tooltip
            key={fieldKey}
            placement="top"
            title={prefixForField}
        >
            <DynamicIcon
                type={iconName as TIconType}
                onClick={handleClick}
            />
        </Tooltip>
    ));
    if (!record[field.key]) {
        return null;
    }
    return (
        <Space>
            {renderIcons()}
        </Space>
    );
};
